import { Injectable } from '@angular/core';
import { lazyInject } from '@app/shared/decorators';
import {
  ModalNotification,
  MODAL_NOTIFICATION_IDS,
  NotificationType,
} from './modal-notification.types';
import { ToastService } from '@app/modules/toast/service/toast.service';
import { ToastParams, Toast } from '@shared/types';
import { v4 as uuid } from 'uuid';
import { ERROR_CONFIGS } from '@config/error.config';
import { I18n } from '@app/i18n/strings-keys';
import { I18nService } from '../i18n/i18n.service';

@Injectable({ providedIn: 'root' })
export class ModalNotificationService {
  @lazyInject(ToastService) private toastService: ToastService;
  @lazyInject(I18nService) private i18nService: I18nService;

  public toast(toast: Toast): ToastParams {
    const defaultConfig = ERROR_CONFIGS.DEFAULT_TOAST_CONFIG;
    const toastParams = { ...defaultConfig, ...toast, id: uuid() };
    this.toastService.processMessages([toastParams]);
    return toastParams;
  }

  public removeToast(toast: ToastParams): void {
    this.toastService.removeToast(toast);
  }

  public createNoInternetConnectionNotification(
    config: Partial<ModalNotification> = {},
  ): ModalNotification {
    return {
      id: MODAL_NOTIFICATION_IDS.NO_INTERNET_CONNECTION_ID,
      title: () =>
        this.i18nService.instant(I18n.CommonNotifications.NoInternetConnection),
      type: NotificationType.warning,
      description: () =>
        this.i18nService.instant(
          I18n.CommonNotifications.NoInternetDescription,
        ),
      priority: 3,
      ...config,
    };
  }

  public createNoNetworkConnectionNotification(
    config: Partial<ModalNotification> = {},
  ): ModalNotification {
    return {
      id: MODAL_NOTIFICATION_IDS.NO_NETWORK_CONNECTION_ID,
      title: () =>
        this.i18nService.instant(I18n.CommonNotifications.NoNetworkConnection),
      type: NotificationType.critical,
      description: () =>
        this.i18nService.instant(I18n.CommonNotifications.NoNetworkDescription),
      priority: 1,
      ...config,
    };
  }
}
